import AntdCol from "antd/es/col";

const Col = AntdCol;

export { Col };
